import { render } from "./ApexchartBlock.vue?vue&type=template&id=5f624274"
import script from "./ApexchartBlock.vue?vue&type=script&lang=js"
export * from "./ApexchartBlock.vue?vue&type=script&lang=js"

import "./ApexchartBlock.vue?vue&type=style&index=0&id=5f624274&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__